module.exports = __webpack_public_path__ + "img/473.208aa5b3.jpg";